import React from 'react';
import AuthFormBlock from '../../components/UI/AuthFormBlock';

const AuthPage = () => {
  return <AuthFormBlock isLogin={false} />;
};

export default AuthPage;
